import React from 'react';
import { Layer, Box, Button, Heading } from 'grommet';
import { Close } from 'grommet-icons';
import VehicleForm from '../forms/vehicle';

const VehicleEnquiry = ({ vehicleID, setShowVehicleEnquiry, branch, dealer }) => (
  <>
    <Layer
      position="right"
      full="vertical"
      modal
      onClickOutside={() => setShowVehicleEnquiry(false)}
      onEsc={() => setShowVehicleEnquiry(false)}
    >
      <Box fill="vertical" overflow="auto" width="large" pad="medium">
        <Box flex={false} direction="row" justify="between">
          <Heading level={2} margin="none">
            Vehicle Enquiry
          </Heading>
          <Button icon={<Close />} onClick={() => setShowVehicleEnquiry(false)} />
        </Box>

        <VehicleForm vehicleID={vehicleID} branch={branch} dealer={dealer} />
      </Box>
    </Layer>
  </>
);

export default VehicleEnquiry;
